import { LinkProps } from "react-router-dom";
import LinkOrSpan, { LinkOrSpanProps } from "../links/LinkOrSpan/LinkOrSpan";

export interface TooltipLinkProps extends Omit<LinkOrSpanProps, "to"> {
  to?: LinkProps["to"];
}

export default function TooltipLink(props: TooltipLinkProps) {
  return (
    <LinkOrSpan
      style={{ cursor: "pointer", color: "#fff", textDecoration: "underline" }}
      {...props}
    />
  );
}
